export enum EPrecoUtilizadoVendaNacional {
  PRECO_CORRENTE = 'Preço Corrente',
  PRECO_PRATICADO = 'Preço Praticado',
}
